export const TIME_ZONE = 'Europe/Zurich';

export const DAY_MONTHNAME_YEAR = 'd. MMMM yyyy';
export const DAY_MONTHNAME = 'd. MMMM';

export const YEAR_MONTH_DAY = 'yyyy-MM-dd';
export const DAY_MONTH_YEAR = 'dd MM yyyy';
export const DAY_MONTH_YEAR_DOTS = 'dd.MM.yyyy';
